// extracted by mini-css-extract-plugin
export var faqAccordion = "faq-accordion-module--faq-accordion--9f7fb";
export var faqAccordion__content = "faq-accordion-module--faq-accordion__content--d1185";
export var faqAccordion__eyebrow = "faq-accordion-module--faq-accordion__eyebrow--9802c";
export var faqAccordion__eyebrow__content = "faq-accordion-module--faq-accordion__eyebrow__content--0e06c";
export var faqAccordion__icon = "faq-accordion-module--faq-accordion__icon--91ad5";
export var faqAccordion__iconCollapse = "faq-accordion-module--faq-accordion__icon-collapse--1b40a";
export var faqAccordion__iconExpand = "faq-accordion-module--faq-accordion__icon-expand--d545d";
export var faqAccordion__item = "faq-accordion-module--faq-accordion__item--41131";
export var faqAccordion__itemOpened = "faq-accordion-module--faq-accordion__item--opened--1f11e";
export var faqAccordion__title = "faq-accordion-module--faq-accordion__title--137bf";
export var faqAccordion__titleClosed = "faq-accordion-module--faq-accordion__title--closed--2ecf6";
export var faqAccordion__titleOpened = "faq-accordion-module--faq-accordion__title--opened--45c39";
export var grid = "faq-accordion-module--grid--b81d7";
export var gridWithRowGap = "faq-accordion-module--grid--with-row-gap--11047";
export var maxWidthContainer = "faq-accordion-module--max-width-container--d4a11";
export var mt0 = "faq-accordion-module--mt-0--900dd";
export var mt1 = "faq-accordion-module--mt-1--ab801";
export var mt2 = "faq-accordion-module--mt-2--49bfa";
export var mt3 = "faq-accordion-module--mt-3--d8ca5";
export var mt4 = "faq-accordion-module--mt-4--d17fa";
export var mt5 = "faq-accordion-module--mt-5--c9287";
export var mt6 = "faq-accordion-module--mt-6--96b57";
export var removeVisuallyHidden = "faq-accordion-module--remove-visually-hidden--ea2b0";
export var visuallyHidden = "faq-accordion-module--visually-hidden--8a45d";
export var widgetBase = "faq-accordion-module--widget-base--821d4";